import React from 'react'
import { useTranslation } from 'react-i18next'
import { AvailabilityDisplayKind } from './types'

const LABEL_KEY: Record<AvailabilityDisplayKind, string | null> = {
  available: 'landing_page.availability_status.available',
  limited: 'landing_page.availability_status.limited_availability',
  contact: 'landing_page.availability_status.contact',
  sold_out: 'landing_page.availability_status.sold_out',
  unknown: null,
}

type AvailabilityStatusLabelProps = {
  kind: AvailabilityDisplayKind
  variant?: 'inline' | 'stacked' | 'legend'
  className?: string
}

export const availabilityStatusAriaLabel = (kind: AvailabilityDisplayKind, t: (key: string) => string): string | undefined => {
  const key = LABEL_KEY[kind]
  return key ? t(key) : undefined
}

const StackedLines: React.FC<{ lines: string[]; className: string; fontSize: string }> = ({ lines, className, fontSize }) => (
  <span className={`text-center leading-tight ${className}`} style={{ fontSize }}>
    {lines.map((line, index) => (
      <React.Fragment key={line}>
        {index > 0 && <br />}
        {line}
      </React.Fragment>
    ))}
  </span>
)

export const AvailabilityStatusLabel: React.FC<AvailabilityStatusLabelProps> = ({ kind, variant = 'inline', className = '' }) => {
  const { t } = useTranslation()
  const key = LABEL_KEY[kind]
  if (!key) return null

  const text = t(key)

  if (variant === 'stacked' && kind === 'limited') {
    const words = text.split(' ')
    const firstLine = words.slice(0, 1).join(' ')
    const secondLine = words.slice(1).join(' ')
    return <StackedLines lines={[firstLine, secondLine].filter(Boolean)} className={className} fontSize="10px" />
  }

  if (variant === 'stacked' && kind === 'contact') {
    const lines = text.split(' ')
    return <StackedLines lines={lines} className={className} fontSize="10px" />
  }

  const fontSize = variant === 'legend' ? '12px' : variant === 'inline' ? '11px' : '10px'

  return (
    <span className={className} style={{ fontSize }}>
      {text}
    </span>
  )
}
